module.exports = __webpack_public_path__ + "img/gpstrategy.a48f6caa.png";